module.exports = __webpack_public_path__ + "static/ritorno-in-het-park-b5e2ee4d3e892c33a9e872cc344fca4f.jpg";